<template>
  <Transition name="fade-fast" appear>
    <MicrositeRenderer
      class="sm:pt-8 lg:pt-12"
      :microsite-details="micrositeDetails"
      without-background
      @microsite-details-item-clicked="handleMicrositeDetailsItemClicked"
    />
  </Transition>
</template>

<script setup lang="ts">
import MicrositeRenderer from '@web/components/microsite/MicrositeRenderer.vue';
import {
  MicrositeDetails,
  MicrositeDetailsItem,
} from '@web/types/objects/MicrositeDetails';
import loadGoogleFontForMicrosite from '@web/components/microsite/loadGoogleFontForMicrosite';
import { ref, watchEffect } from 'vue';
import { useOnTabVisible } from '@web/composables/useOnTabVisible';
import { CanceledError } from 'axios';
import notifyError from '@web/utils/notifyError';

const micrositeDetails = ref<MicrositeDetails>(
  window.Clearstream['micrositeDetails'] as MicrositeDetails,
);

watchEffect(() => {
  loadGoogleFontForMicrosite(micrositeDetails.value.fontFamily);
});

let refreshAbortController: AbortController | null = null;

async function refreshDetails(): Promise<void> {
  refreshAbortController?.abort();
  refreshAbortController = new AbortController();

  try {
    const response = await axios.get<MicrositeDetails>(window.location.href, {
      signal: refreshAbortController.signal,
    });
    micrositeDetails.value = response.data;
  } catch (error) {
    if (error instanceof CanceledError) {
      return;
    }
    // Background refresh; don't surface to the user or break the page.
    notifyError(error);
  }
}

useOnTabVisible(() => {
  refreshDetails();
});

function handleMicrositeDetailsItemClicked(
  micrositeDetailsItem: MicrositeDetailsItem,
): void {
  if (micrositeDetailsItem.id === null) {
    return;
  }

  axios
    .post('/api/microsite-item-clicks', {
      microsite_item_id: micrositeDetailsItem.id,
    })
    .finally(() => {
      //
    });
}
</script>
